/* L'inducteur d'une offre (2026-09-07) : le temps se compte en heures ou en
   jours-homme (choix fermé, l'Analytique compte des heures) ; toute autre
   équation nomme son inducteur librement, la liste ci-dessous servant de
   propositions et de libellés. Une unité connue se stocke par sa clé, un texte
   libre tel quel. */
export const TIME_UNITS = ['h', 'jh'];   // l'EPT attendra qu'on le demande (2026-09-11)
/* Une journée FACTURÉE fait huit heures (décision 2026-09-11) : c'est la convention
   du tarif journalier, pas le calendrier de l'entreprise (42 h par semaine font
   8.4 h de présence, on n'en facture pas 8.4). Une seule constante pour la
   fenêtre de l'offre et le plan mensuel. */
export const HEURES_JOUR = 8;
/* La conversion d'une quantité entre ce qu'on STOCKE et ce qu'on LIT (2026-10-20).
   `k` = unités lues par unité stockée (1/8 pour des heures lues en jours-hommes).
   La cellule reçoit DÉJÀ la valeur lue (`aff`) : son brouillon de saisie la
   reprend telle quelle. Le convertir une seconde fois faisait passer 6 jours à
   0.75 au simple clic dans la cellule. */
export const lectureTemps = (k) => ({
  aff: (x) => (x == null ? null : x * k),
  draft: (x) => (x == null ? '' : String(Math.round(x * 100) / 100)),
  brute: (x) => (x == null ? null : Math.round((x / k) * 1000) / 1000),
});
const LABELS = (p) => ({
  h: p('heure'), jh: p('jour-homme'), ept: p('EPT'), pkg: p('forfait'), contract: p('contrat'), unit: p('unité'), kchf: 'kCHF',
  seat: p('place'), participant: p('participant'), formation: p('formation'),
});
export const libelleUnite = (p, u) => (u ? (LABELS(p)[u] || u) : '—');
/* Le texte tapé : la clé d'une unité connue quand il en reprend le libellé, sinon lui-même. */
export const cleUnite = (p, txt) => {
  const t = String(txt || '').trim();
  if (!t) return null;
  const found = Object.entries(LABELS(p)).find(([, l]) => l.toLowerCase() === t.toLowerCase());
  return found ? found[0] : t;
};

/* Les équations SANS inducteur (2026-09-08), donc sans volume ni prix unitaire :
   une commission se calcule sur une assiette, un montant planifié se tape. Les
   cellules concernées disent « n/a », pas un tiret : elles ne sont pas vides,
   elles sont sans objet. La règle vit ICI, et non dans chaque écran : l'Offre et
   la Trajectoire l'ont écrite deux fois, et ont fini par ne plus dire la même chose. */
export const sansInducteur = (o) => o.equation === 'base_rate' || o.equation === 'project';
